export default "__VITE_ASSET__7b507939__"